import {
  GETVIEWCUSTOMERBANKDETAILS_SUCCESS,
  GETVIEWCUSTOMERBANKDETAILS_FAILED,
  RESET_GETVIEWCUSTOMERBANKDETAILS,
  LOADING_GETVIEWCUSTOMERBANKDETAILS,
  NETWORK_ERROR_GETVIEWCUSTOMERBANKDETAILS,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GETVIEWCUSTOMERBANKDETAILS:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case GETVIEWCUSTOMERBANKDETAILS_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case GETVIEWCUSTOMERBANKDETAILS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_GETVIEWCUSTOMERBANKDETAILS:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_GETVIEWCUSTOMERBANKDETAILS:
      return (state = initialState);
    default:
      return state;
  }
};
